import { render, staticRenderFns } from "./WholesalersData.vue?vue&type=template&id=07cea580"
import script from "./WholesalersData.vue?vue&type=script&lang=js"
export * from "./WholesalersData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07cea580')) {
      api.createRecord('07cea580', component.options)
    } else {
      api.reload('07cea580', component.options)
    }
    module.hot.accept("./WholesalersData.vue?vue&type=template&id=07cea580", function () {
      api.rerender('07cea580', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/payment/WholesalersData.vue"
export default component.exports